import React from 'react'
import HeroBanner from './HeroBanner'
import ChecklistSplash from './ChecklistSplash'
import HelloBabyBoxSection from './HelloBabyBoxSection'
import * as css from './RebrandedHome.scss'
import GuidesSection from './GuidesSection'
import ShopSection from './ShopSection'
import CongratulationsSection from './CongratulationsSection'
import HealthSection from './HealthSection'
import SummarizedNav from './SummarizedNav'

const RebrandedHome = () => (
  <div className={css.HomepageContainer}>
    <HeroBanner />
    <ChecklistSplash />
    <ShopSection />
    <HelloBabyBoxSection />
    <GuidesSection />
    <HealthSection />
    <CongratulationsSection />
    <SummarizedNav />
  </div>
)

export default RebrandedHome
